import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const BlackFriday = lazy(
  () =>
    import('./BlackFriday.eager').then(mod => ({
      default: mod.BlackFriday,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
